import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "../App";

const BrandingContext = createContext(null);

const FALLBACK = {
  brand_name: "TableCy",
  brand_name_el: "TableCy",
  tagline: "",
  tagline_el: "",
  logo_svg: "",
  logo_url: "",
  use_image: false,
};

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(FALLBACK);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/branding`);
      setBranding({ ...FALLBACK, ...res.data });
    } catch {
      setBranding(FALLBACK);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <BrandingContext.Provider value={{ branding, loaded, refresh, setBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const ctx = useContext(BrandingContext);
  if (!ctx) throw new Error("useBranding must be used within BrandingProvider");
  return ctx;
}
